import {
  AUSTRALIAN_SUPER_PLUGIN_NAME,
  effectiveAustralianSuperGraphqlUrl,
} from "./australian-super.plugin-config";

/** Static plugin row used when resolving vault URL for GraphQL fetch. */
export type PluginFetchRegistration = {
  id: string;
  name: string;
  url: string;
  apiKey?: string;
};

type VaultPluginRef = { name: string; url: string; apiKey?: string };

function resolvePluginUrl(pluginName: string, staticUrl: string, vaultUrl?: string): string {
  if (pluginName === AUSTRALIAN_SUPER_PLUGIN_NAME) {
    return effectiveAustralianSuperGraphqlUrl(vaultUrl ?? staticUrl);
  }
  return vaultUrl?.trim() || staticUrl;
}

/**
 * Merge static plugin registration with vault-stored URL (and apiKey) when the plugin is installed.
 * Australian Super always uses the live endpoint on UAT/PROD (localhost only when IS_LOCAL).
 */
export function resolvePluginConfigForFetch<T extends PluginFetchRegistration>(
  pluginId: string,
  staticConfigs: T[],
  vaultPlugins: VaultPluginRef[],
): T | undefined {
  const base = staticConfigs.find((c) => c.id === pluginId);
  if (!base) {
    return undefined;
  }
  const vault = vaultPlugins.find((p) => p.name === base.name);
  const url = resolvePluginUrl(base.name, base.url, vault?.url);
  return {
    ...base,
    url,
    apiKey: vault?.apiKey ?? base.apiKey,
  };
}
